import { render, staticRenderFns } from "./TitleDashboard.vue?vue&type=template&id=6ffb5298&scoped=true&"
import script from "./TitleDashboard.vue?vue&type=script&lang=js&"
export * from "./TitleDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TitleDashboard.vue?vue&type=style&index=0&id=6ffb5298&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffb5298",
  null
  
)

export default component.exports